import React from 'react';
import { movdTokens } from './movdTokens.js';

// Shared chrome for the customer quote journey (Build → Details → Inventory →
// Review). Keeps the header, step progress, and the form/aside two-column
// layout consistent across every stage instead of each stage inventing its
// own scaffolding. Business logic and stage-specific fields stay with the
// caller — this component only owns structure and progress.
export default function MovdJourneyShell({ eyebrow = 'MOVD / BUILD YOUR MOVE', tagline = 'One move. All the way through.', onExit, steps, currentStep, aside, children }) {
  const activeIndex = Math.max(0, steps.findIndex(step => step.key === currentStep));

  return (
    <div style={{
      background: movdTokens.color.ink,
      color: movdTokens.color.text,
      minHeight: '100vh',
      padding: '16px 16px',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
    }}>
      <style>{`
        .movd-journey-aside { order: -1; }
        @media (min-width: 1200px) {
          .movd-journey-shell { height: 100vh; min-height: 0; overflow: hidden; padding: 16px 40px; }
          .movd-journey-grid { display: grid; grid-template-columns: minmax(0, .95fr) minmax(440px, 1.15fr); height: 100%; flex: 1; min-height: 0; }
          .movd-journey-form { height: 100%; min-height: 0; overflow-y: auto; }
          .movd-journey-aside { height: 100%; max-height: 460px; align-self: center; order: 0; }
        }
      `}</style>
      <div className="movd-journey-shell" style={{ maxWidth: movdTokens.size.contentMaxWidth, margin: '0 auto', width: '100%', display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
        <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0, marginBottom: 16 }}>
          <div>
            <p style={{ margin: 0, color: movdTokens.color.tealSoft, fontSize: '.68rem', fontWeight: 900, letterSpacing: '.18em' }}>{eyebrow}</p>
            <p style={{ margin: '4px 0 0', fontSize: '1.2rem', fontWeight: 900 }}>{tagline}</p>
          </div>
          <button
            type="button"
            onClick={onExit}
            style={{ background: 'transparent', border: 'none', color: 'rgba(255,255,255,.7)', font: 'inherit', fontSize: '.9rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}
          >
            ‹ Exit
          </button>
        </header>

        <nav aria-label="Move journey progress" style={{ display: 'flex', gap: 6, flexShrink: 0, marginBottom: 20 }}>
          {steps.map((step, index) => (
            <span
              key={step.key}
              title={step.label}
              style={{
                flex: 1,
                height: 3,
                borderRadius: 2,
                background: index <= activeIndex ? movdTokens.color.teal : 'rgba(255,255,255,.16)',
                transition: `background ${movdTokens.motion.standard}`,
              }}
            />
          ))}
        </nav>

        <div className="movd-journey-grid" style={{ display: 'flex', flexDirection: 'column', gap: 24, flex: 1, minHeight: 0 }}>
          <div className="movd-journey-form" style={{ display: 'flex', flexDirection: 'column', paddingRight: 4 }}>
            {children}
          </div>
          <div className="movd-journey-aside" style={{ width: '100%', minHeight: 220, height: 260, border: '1px solid rgba(125,211,252,.22)', background: movdTokens.color.inkSoft, overflow: 'hidden' }}>
            {aside}
          </div>
        </div>
      </div>
    </div>
  );
}
